export default {
  en: {
    banner: {
      desc: 'Binance Community Vote: Round @1',
    },
    record: {
      title: 'Community Vote',
      breadTitle: 'My Voting History',
      trList: ['Voting Time', 'Project', 'Ticker', 'Number of Votes'],
    },
  },
  cn: {
    banner: {
      desc: '币安第@1期投票上币',
    },
    record: {
      title: '上币投票',
      breadTitle: '我的投票记录',
      trList: ['投票时间', '投票项目', '投票币种', '投票数量'],
    },
  },
};
